import DataServiceSQL from "../DataService/DataServiceSQL";

//Function to convert group from FHIR
const convert_fhir_group = (groups) => {
  let ret = [];
  groups.forEach(group => {
    let new_group = {
      id_group: group.identifier,
      group_name: group.name,
      description: group.description,
      group_type: group.group_type
    }
    ret.push(new_group)
  })
  return (ret)
}

//Function to retrieve SQL structure group list
const get_Structure_Groups = async () => {
    return await DataServiceSQL.getStructureGroups_fhir()
      .then((response) => {
        if(response.data !== undefined){
          response.data = convert_fhir_group(response.data.entry)
          return (response.data);
        }
        else{
          return "none";
        }
      })
      .catch((e) => {
        console.log(e);
      });
};

//Function to retrieve SQL structure group by name
const get_Structure_Groups_by_name = async (name) => {
    return await DataServiceSQL.findGroupReq_fhir(name)
      .then((response) => {
        if(response.data !== undefined){
          response.data = convert_fhir_group(response.data.entry)
          return (response.data);
        }
        else{
          return "none";
        }
      })
      .catch((e) => {
        console.log(e);
      });
};

//Const to import functions in other files
const GroupsFunctionsGetter = {
  get_Structure_Groups,
  get_Structure_Groups_by_name
};

export default GroupsFunctionsGetter;